import { graphql } from 'relay-runtime'

export const metaAdApproveMutation = graphql`
  mutation MetaAdApproveMutation(
    $input: UpdateMetaAdRequest!
    $metaAdsFilter: MetaAdsFilter
  ) {
    updateMetaAd(input: $input, metaAdsFilter: $metaAdsFilter) {
      id
      approved
      brand {
        id
        approvedMetaAdCount
        unapprovedMetaAdCount
        invalidDraftMetaAdCount
        ...CreativeList
      }
    }
  }
`
